import { getWindow } from "@faire/web/common/globals/getWindow";
import { RefObject, useState, useEffect, useCallback } from "react";

export const useNumHiddenTiles = (
  containerRef: RefObject<HTMLElement | null>,
  tileRef: RefObject<HTMLElement | null>,
  columnSpacingPixels: number,
  numTiles: number
) => {
  const calculateNumHiddenTiles = useCallback(() => {
    const { width: containerWidth, height: containerHeight } =
      containerRef.current?.getBoundingClientRect() ?? {};
    const { width: tileWidth, height: tileHeight } =
      tileRef.current?.getBoundingClientRect() ?? {};
    if (containerWidth && containerHeight && tileWidth && tileHeight) {
      const tilesPerRow = Math.floor(
        containerWidth / (tileWidth + columnSpacingPixels)
      );
      const numRowsVisible = Math.floor(containerHeight / tileHeight);

      return numTiles - tilesPerRow * numRowsVisible;
    }

    return undefined;
  }, [columnSpacingPixels, containerRef, tileRef, numTiles]);

  const [numHiddenTiles, setNumHiddenTiles] = useState<number | undefined>(() =>
    calculateNumHiddenTiles()
  );

  useEffect(() => {
    if (!containerRef.current) {
      return;
    }

    const window = getWindow();
    if (!window) {
      return;
    }

    const observer = new window.ResizeObserver(() => {
      setNumHiddenTiles(calculateNumHiddenTiles());
    });

    observer.observe(containerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [calculateNumHiddenTiles, containerRef]);

  return numHiddenTiles;
};
